import React, { useEffect, useRef, useState } from "react";
import "./../assets/css/resetPassword.css";
import { url } from "../config";
import toast from "../utils/toast";

const ResetPasswordModal = ({ onClose, mobile }) => {
    mobile = typeof mobile === "object" ? mobile.mobile : mobile;
    const modalRef = useRef(null);
    const instanceRef = useRef(null);

    const [form, setForm] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    // const [showPassword, setShowPassword] = useState({
    //     old: false,
    //     new: false,
    //     confirm: false
    // });

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const elem = modalRef.current;

        instanceRef.current = window.M.Modal.init(elem, {
            dismissible: false, onCloseEnd: () => {
                if (closeModal) closeModal();
            }
        });

        instanceRef.current.open();

    }, []);

    const closeModal = () => {
        localStorage.removeItem("resetPassword");
        localStorage.removeItem("authKey");
        if (instanceRef.current) {
            instanceRef.current.close();
        }

    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    // const togglePassword = (field) => {
    //     setShowPassword({
    //         ...showPassword,
    //         [field]: !showPassword[field]
    //     });
    // };

    const strongPassword = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

    const handleSubmit = async () => {
        if (!form.oldPassword) {
            toast("Old password is required"); return;
        }

        if (!form.newPassword) {
            toast("New password is required"); return;
        } else if (!strongPassword.test(form.newPassword)) {
            toast("Password must contain at least 8 characters, 1 number and 1 letter"); return;
        }

        if (!form.confirmPassword) {
            toast("Confirm password is required"); return;
        } else if (form.newPassword !== form.confirmPassword) {
            toast("Passwords do not match"); return;
        }

        setLoading(true);

        try {

            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    // Authorization: "Bearer " + localStorage.getItem("authKey"),
                },
                body: new URLSearchParams({
                    workforce: "changePassword",
                    mobile: mobile,
                    oldPassword: form.oldPassword,
                    newPassword: form.newPassword
                })
            });

            const data = await res.json();

            if (data.Result === 1) {

                toast("Password updated successfully", "success");

                setForm({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });

                closeModal();
                onClose();

            } else {

                toast(data.Message || "Failed to update password");

            }

        } catch (error) {

            console.error(error);
            toast("Server error occurred");

        }

        setLoading(false);
    };

    return (
        <div className="modal reset-password-modal" ref={modalRef}>
            <div className="modal-header" style={{ padding: "10px",color:"black" }}>
                            <h5 className="modal-title">
                            <span className="left">Reset Password</span>
                            <i className="material-icons right" style={{ cursor: "pointer","fontWeight": "bolder",lineHeight: "1" }} onClick={closeModal}>
                                close
                            </i>
                            </h5>
            </div>
            <div className="modal-content" style={{marginTop:"15px"}}>
              {/* Old Password */}
                <div className="password-field">
                    <div className="input-field">
                    <label htmlFor="oldPassword">Old Password</label>
                <input
                    type="password"
                    name="oldPassword"
                    id="oldPassword"
                    value={form.oldPassword}
                    onChange={handleChange}
                    required
                />

                    </div>


                </div>

                {/* New Password */}
                <div className="password-field">
                <div className="input-field">
                <label htmlFor="newPassword">New Password</label>
                <input
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    value={form.newPassword}
                    onChange={handleChange}
                    required
                />

                </div>
                </div>

                {/* Confirm Password */}
                <div className="password-field">
                    <div className="input-field">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    required/>

                    </div>
                </div>
            </div>

            
            <div className="modal-footer reset-footer">

                <button
                className="btn-login"
                onClick={handleSubmit}
                disabled={loading}
                >
                    UPDATE
                {loading ? (
                    <>
                    <span className="spinner"></span>
                    </>
                ) : (
                    ""
                )}
                </button>

            </div>
        </div>

    );
};

export default ResetPasswordModal;

